export const REQUIRED_SHEETS = [
  "Main",
  "Services",
  "Diagnosis",
  "Practitioner",
  // "Lab",
  // "Rad",
  "Optical",
];
export const REQUIRED_HEADER = {
  Main: [
    "Claim_Seq_No",
    "Membership_No",
    "Patient_File_No",
    "Patient_Name",
    "MobileNumber",
    "Policy_No",
    "Patient_IdentifierType",
    "Patient_ID",
    "Patient_Class",
    "Patient_Gender",
    "Patient_DateofBirth",
    "Nationality",
    "Claim_Date",
    "Eposide_No",
    "Chief_Complaint",
    "Claim_Type",
    "Claim_Sub_Type",
    "IsPrescription",
    "PrescriptionRefNo",
    "Temperature",
    "Respiratory_rate",
    "DurationOfIllness",
    "Admission_Weight",
    "AdmissionWeight",
    "Birth_Weight",
    "last_menstral_code",
    "Diastolic_B.P",
    "Height",
    "Weight",
    "Pulse",
    "Systolic_B.P",
    "OxygenSaturation",
    "Significant_Sign",
    "Clinical_Data",
    "Other_Condition",
    "Is_Newborn",
    "Policy_Name",
    "Newborn_MRN",
    "Relationship",
    "BeneficiaryMRN",
    "BeneficiaryGender",
    "BeneficiaryFirstName",
    "BeneficiaryLastName",
    "BeneficiaryBirthDate",
    "Visit_Type",
    "AdmissionDate",
    "DischargeDate",
    "DischargeSpeciality",
    "CareType",
    "TriageCategoryType",
    "DepartmentDisposition",
    "Patient_Occupation",
    "Patient_Religion",
    "Patient_MaritalStatus",
    "TreatmentPlan",
    "PatientHistory",
    "PhysicalExamination",
    "HistoryOfPresentIllness",
    "TriageDate",
    "ServiceEventType",
    "CauseOfDeath",
    "EmergencyServiceStartDate",
    "EmergencyArrivalCode",
    "EmergencyDepartmentDisposition",
    "IntendedLengthOfStay",
    "EstimatedLengthOfStay",
    "EncounterClass",
    "EncounterAdmitSource",
    "DischargeDisposition",
    "EncounterStatus",
    "ICUHours",
    "VentilationHours",
    "AccidentDate",
    "AccidentType",
    "Accident Address",
    "MissingToothNumber",
    "MissingToothReason",
    "MissingToothDate",
  ],
  Services: [
    "Claim_Seq_No",
    "Invoice_No",
    "ServiceType",
    "Service_Code",
    "Provider_Code",
    "Service_Description",
    "DaysSupply",
    "Tooth_No",
    "ToothSurface",
    "Service_date",
    "Qty",
    "Unit_Price",
    "Gross_Amount",
    "DiscountPercentage",
    "Stength",
    "Net_After_Discount",
    "Deductible",
    "Net_Payable_Amount",
    "PatientVatAmount",
    "NetVatAmount",
    "VatIndicator",
    "PREAUTH",
    "BodySite",
    "BodySubSite",
    "DiagnosisCode",
    "IsMaternity",
    "MedicationServiceType",
    "MedicationServiceCode",
    "MedicationScientificCode",
    "MedicationScientificCodeAbsenceReason",
    "MedicationScientificCodeAbsenceReasonOthers",
    "MedicationSelectionReason",
    "MedicationPharmacySubstitute",
    "MedicationPharmacySubstituteOther",
    "MedicationStartDate",
    "MedicationEndDate",
    "MedicationDuration",
    "MedicationDurationUnit",
    "MedicationFrequency",
    "MedicationPeriod",
    "MedicationPeriodunit",
    "MedicationDose",
    "MedicationDoseunit",
    "MedicationRoute",
    "MedicationTimeInstruction",
    "MedicationRefillCount",
    "MedicationDosageInstruction",
    "MedicationPatientInstruction",
  ],
  Diagnosis: [
    "Claim_Seq_No",
    "Invoice_No",
    "ICD10_Code",
    "DiagnosisType",
    "DiagnosisDate",
    "ConditionOnset",
    "OnAdmission",
  ],
  Lab: [
    "Claim_Seq_No",
    "INVOICE_NO",
    "Result_Date",
    "Service_Code",
    "Service_Date",
    "MRNO",
    "LAB_VISIT_DATE",
    "LAB_PROFILE",
    "LAB_TEST_NAME",
    "Lab_Result",
    "Lab_Units",
    "Lab_Low",
    "Lab_High",
    "Lab_Section",
    "LoincCode",
  ],
  Rad: [
    "Claim_Seq_No",
    "INVOICE_NO",
    "MRNO",
    "RADIO_DATE",
    "Result_Date",
    "Service_Date",
    "SERV_CODE",
    "SERV_DESC",
    "RR_TEXT",
  ],
  Optical: [
    "Claim_Seq_No",
    "Product_Type",
    "PrescriptionDate",
    "Regular_Lenses_Type",
    "Lense_Specification",
    "Contact_Lense_Type",
    "Is_Frame",
    "PD",
    "Right_Add",
    "Right_Eye_Distance_SPH",
    "Right_Eye_Distance_CYL",
    "Right_Eye_Distance_AXIS",
    "Right_Eye_Distance_POWER",
    "Right_Eye_Near_SPH",
    "Right_Eye_Near_CYL",
    "Right_Eye_Near_AXIS",
    "Right_Eye_Near_POWER",
    "Left_Add",
    "Left_Eye_Distance_SPH",
    "Left_Eye_Distance_CYL",
    "Left_Eye_Distance_AXIS",
    "Left_Eye_Distance_POWER",
    "Left_Eye_Near_SPH",
    "Left_Eye_Near_CYL",
    "Left_Eye_Near_AXIS",
    "Left_Eye_Near_POWER",
    "Left_Eye_Distance_Diameter",
    "Left_Eye_Near_Diameter",
    "Right_Eye_Distance_Diameter",
    "Right_Eye_Near_Diameter",
    "Left_Eye_Distance_BackCurve",
    "Left_Eye_Near_BackCurve",
    "Right_Eye_Distance_BackCurve",
    "Right_Eye_Near_BackCurve",
    "Left_Eye_Distance_PrimIN",
    "Left_Eye_Near_PrimIN",
    "Right_Eye_Distance_PrimIN",
    "Right_Eye_Near_PrimIN",
    "Left_Eye_Distance_PrismOut",
    "Left_Eye_Near_PrismOut",
    "Right_Eye_Distance_PrismOut",
    "Right_Eye_Near_PrismOut",
    "Left_Eye_Distance_PrismUp",
    "Left_Eye_Near_PrismUp",
    "Right_Eye_Distance_PrismUp",
    "Right_Eye_Near_PrismUp",
    "Left_Eye_Distance_PrismDown",
    "Left_Eye_Near_PrismDown",
    "Right_Eye_Distance_PrismDown",
    "Right_Eye_Near_PrismDown",
    "LeftDuration",
    "LeftDurationUnit",
    "RightDuration",
    "RightDurationUnit",
  ],
  Practitioner: [
    "Claim_Seq_No",
    "LicenseNumber",
    "DOCTOR_NAME",
    "SPECIALTY",
    "ROLE",
  ],
};
export const REQUIRED_FIELDS = {
  Main: [
    "Claim_Seq_No",
    "Membership_No",
    "Patient_File_No",
    "Patient_Name",
    "Policy_No",
    "Patient_IdentifierType",
    "Patient_ID",
    "Patient_Class",
    "Relationship",
    "Patient_Gender",
    "Patient_Occupation",
    "Patient_DateofBirth",
    "Claim_Date",
    "Chief_Complaint",
    "Policy_Name",
    "Patient_MaritalStatus",
    "Claim_Type",
    "Claim_Sub_Type",
    "Visit_Type",
    "TreatmentPlan",
    "PatientHistory",
    "PhysicalExamination",
    "HistoryOfPresentIllness",
  ],
  Services: [
    "Claim_Seq_No",
    "Invoice_No",
    "Service_Code",
    "Service_Description",
    "Provider_Code",
    "Service_date",
    "Qty",
    "Unit_Price",
    "Gross_Amount",
    "Net_Payable_Amount",
  ],
  Diagnosis: [
    "Claim_Seq_No",
    "Invoice_No",
    "ICD10_Code",
    "DiagnosisType",
    "ConditionOnset",
  ],
  Lab: [
    "Claim_Seq_No",
    "INVOICE_NO",
    "Service_Code",
    "Service_Date",
    "LoincCode",
  ],
  Rad: ["Claim_Seq_No", "INVOICE_NO", "Service_Date", "SERV_CODE", "SERV_DESC"],
  Practitioner: [
    "Claim_Seq_No",
    "LicenseNumber",
    "DOCTOR_NAME",
    "SPECIALTY",
    "ROLE",
  ],
};
export const identifierTypeFullList = [
  {
    ident_type_id: 1,
    ident_type_name: "Iqama",
  },
  {
    ident_type_id: 2,
    ident_type_name: "Border Number",
  },
  {
    ident_type_id: 3,
    ident_type_name: "VISA",
  },
  {
    ident_type_id: 4,
    ident_type_name: "Passport Number",
  },
  {
    ident_type_id: 5,
    ident_type_name: "MR Number",
  },
  {
    ident_type_id: 6,
    ident_type_name: "National ID",
  },
];
export const claimSubTypeFullList = [
  {
    claimsub_types_id: 1,
    claimsub_types_code: "ip",
    claimsub_types_name: "InPatient",
    claimsub_types_dflt: 0,
  },
  {
    claimsub_types_id: 2,
    claimsub_types_code: "op",
    claimsub_types_name: "OutPatient",
    claimsub_types_dflt: 0,
  },
  {
    claimsub_types_id: 3,
    claimsub_types_code: "emr",
    claimsub_types_name: "Emergency",
    claimsub_types_dflt: 0,
  },
];
export const claimTypeFullList = [
  {
    claim_types_id: 1,
    claim_types_code: "institutional",
    claim_types_name: "Institutional",
    claim_types_dflt: 0,
  },
  {
    claim_types_id: 2,
    claim_types_code: "oral",
    claim_types_name: "Dental",
    claim_types_dflt: 0,
  },
  {
    claim_types_id: 3,
    claim_types_code: "pharmacy",
    claim_types_name: "Pharmacy",
    claim_types_dflt: 0,
  },
  {
    claim_types_id: 4,
    claim_types_code: "professional",
    claim_types_name: "Professional",
    claim_types_dflt: 0,
  },
  {
    claim_types_id: 5,
    claim_types_code: "vision",
    claim_types_name: "Vision",
    claim_types_dflt: 0,
  },
];
export const dischargeSpecialtyFullList = [
  {
    specialities_code: "01.00",
    specialities_name: "Anesthesiology Specialty",
  },
  {
    specialities_code: "01.01",
    specialities_name: "Ambulatory Anesthesia",
  },
  {
    specialities_code: "01.02",
    specialities_name: "Anesthesia Cardiology",
  },
  {
    specialities_code: "01.03",
    specialities_name: "Neuro-Anesthesia",
  },
  {
    specialities_code: "01.04",
    specialities_name: "Obstetrics Anesthesia",
  },
  {
    specialities_code: "01.05",
    specialities_name: "Pediatrics Anesthesia",
  },
  {
    specialities_code: "01.06",
    specialities_name: "Pediatrics Cardiac Anesthesia",
  },
  {
    specialities_code: "01.07",
    specialities_name: "Regional Anesthesia",
  },
  {
    specialities_code: "01.08",
    specialities_name: "Vascular / Thoracic Anesthesia",
  },
  {
    specialities_code: "02.00",
    specialities_name: "Community Medicine Specialty",
  },
  {
    specialities_code: "02.01",
    specialities_name: "Community Health",
  },
  {
    specialities_code: "03.00",
    specialities_name: "Dermatology Specialty",
  },
  {
    specialities_code: "03.01",
    specialities_name: "Dermatology Surgery",
  },
  {
    specialities_code: "03.02",
    specialities_name: "Hair Implant Dermatology",
  },
  {
    specialities_code: "03.03",
    specialities_name: "Pediatrics Dermatology",
  },
  {
    specialities_code: "04.00",
    specialities_name: "Emergency Medicine Specialty",
  },
  {
    specialities_code: "04.01",
    specialities_name: "Adult Emergency Medicine",
  },
  {
    specialities_code: "04.02",
    specialities_name: "Pediatrics Emergency Medicine",
  },
  {
    specialities_code: "05.00",
    specialities_name: "Ear, Nose & Throat Specialty",
  },
  {
    specialities_code: "05.01",
    specialities_name: "Adult ENT",
  },
  {
    specialities_code: "05.02",
    specialities_name: "Laryngology",
  },
  {
    specialities_code: "05.03",
    specialities_name: "Neuro - Otology & Otology",
  },
  {
    specialities_code: "05.04",
    specialities_name: "Nose, Ear Surgery",
  },
  {
    specialities_code: "05.05",
    specialities_name: "Oral & Maxillofacial Surgery",
  },
  {
    specialities_code: "05.06",
    specialities_name: "Otolaryngology",
  },
  {
    specialities_code: "05.07",
    specialities_name: "Pediatrics ENT",
  },
  {
    specialities_code: "05.08",
    specialities_name: "Pediatrics Otolaryngology",
  },
  {
    specialities_code: "05.09",
    specialities_name: "Rhinology",
  },
  {
    specialities_code: "05.10",
    specialities_name: "Audiology",
  },
  {
    specialities_code: "06.00",
    specialities_name: "Family Medicine Specialty",
  },
  {
    specialities_code: "06.01",
    specialities_name: "Family Medicine",
  },
  {
    specialities_code: "06.02",
    specialities_name: "Primary Care / Ophthalmology",
  },
  {
    specialities_code: "06.03",
    specialities_name: "Primary Care / Pulmonary",
  },
  {
    specialities_code: "06.04",
    specialities_name: "Primary Care Preventive Pediatrics",
  },
  {
    specialities_code: "06.05",
    specialities_name: "Primary Health Care",
  },
  {
    specialities_code: "07.00",
    specialities_name: "Forensic Medicine Specialty",
  },
  {
    specialities_code: "08.00",
    specialities_name: "Internal Medicine Specialty",
  },
  {
    specialities_code: "08.01",
    specialities_name: "Adolescent Medicine",
  },
  {
    specialities_code: "08.02",
    specialities_name: "Cardiology",
  },
  {
    specialities_code: "08.03",
    specialities_name: "Diabetics Medicine",
  },
  {
    specialities_code: "08.04",
    specialities_name: "Endocrinology",
  },
  {
    specialities_code: "08.05",
    specialities_name: "Gastrology/Gastroenterology",
  },
  {
    specialities_code: "08.06",
    specialities_name: "Geriatrics",
  },
  {
    specialities_code: "08.07",
    specialities_name: "Hematology",
  },
  {
    specialities_code: "08.08",
    specialities_name: "Infectious Diseases",
  },
  {
    specialities_code: "08.09",
    specialities_name: "Nephrology",
  },
  {
    specialities_code: "08.10",
    specialities_name: "Nuclear Medicine",
  },
  {
    specialities_code: "08.11",
    specialities_name: "Oncology",
  },
  {
    specialities_code: "08.12",
    specialities_name: "Palliative Medicine",
  },
  {
    specialities_code: "08.13",
    specialities_name: "Pulmonology/Chest Medicine",
  },
  {
    specialities_code: "08.14",
    specialities_name: "Rheumatology",
  },
  {
    specialities_code: "08.15",
    specialities_name: "Sleep Medicine",
  },
  {
    specialities_code: "08.16",
    specialities_name: "Sport Medicine",
  },
  {
    specialities_code: "08.17",
    specialities_name: "Hepatology",
  },
  {
    specialities_code: "08.18",
    specialities_name: "Neurology",
  },
  {
    specialities_code: "08.19",
    specialities_name: "Radiation Oncology",
  },
  {
    specialities_code: "08.20",
    specialities_name: "Diabetes Foot Care",
  },
  {
    specialities_code: "08.21",
    specialities_name: "Head & Neck Oncology",
  },
  {
    specialities_code: "08.22",
    specialities_name: "Hematology - Stem Cell",
  },
  {
    specialities_code: "08.23",
    specialities_name: "Congenital Heart Disease",
  },
  {
    specialities_code: "08.24",
    specialities_name: "Bariatric Medicine",
  },
  {
    specialities_code: "08.25",
    specialities_name: "Cardiothoracic",
  },
  {
    specialities_code: "08.26",
    specialities_name: "General Medicine",
  },
  {
    specialities_code: "09.00",
    specialities_name: "Microbiology Specialty",
  },
  {
    specialities_code: "10.00",
    specialities_name: "Obstetrics & Gynecology Specialty",
  },
  {
    specialities_code: "10.01",
    specialities_name: "Gynecology Oncology",
  },
  {
    specialities_code: "10.02",
    specialities_name: "Infertility",
  },
  {
    specialities_code: "10.03",
    specialities_name: "IVF",
  },
  {
    specialities_code: "10.04",
    specialities_name: "Perinatology",
  },
  {
    specialities_code: "10.05",
    specialities_name: "Urogynecology",
  },
  {
    specialities_code: "10.06",
    specialities_name: "Obstetrics",
  },
  {
    specialities_code: "10.07",
    specialities_name: "Reproductive Endocrinology & Infertility",
  },
  {
    specialities_code: "10.08",
    specialities_name: "Gynecology",
  },
  {
    specialities_code: "10.09",
    specialities_name: "Maternal Fetal Medicine",
  },
  {
    specialities_code: "11.00",
    specialities_name: "Ophthalmology Specialty",
  },
  {
    specialities_code: "11.01",
    specialities_name: "Comprehensive Ophthalmology",
  },
  {
    specialities_code: "11.02",
    specialities_name: "Diseases & Surgery of the Retina",
  },
  {
    specialities_code: "11.03",
    specialities_name: "Glaucoma",
  },
  {
    specialities_code: "11.04",
    specialities_name: "Neuro - Ophthalmology",
  },
  {
    specialities_code: "11.05",
    specialities_name: "Ocular Oncology",
  },
  {
    specialities_code: "11.06",
    specialities_name: "Oculoplastic",
  },
  {
    specialities_code: "11.07",
    specialities_name: "Ophthalmology",
  },
  {
    specialities_code: "11.08",
    specialities_name: "Pediatrics Ophthalmology & Strabismus",
  },
  {
    specialities_code: "11.09",
    specialities_name: "Primary Care / Ophthalmology",
  },
  {
    specialities_code: "11.10",
    specialities_name: "Uveitis / Medical Retina",
  },
  {
    specialities_code: "11.11",
    specialities_name: "Optometric",
  },
  {
    specialities_code: "11.12",
    specialities_name: "Anterior Segment",
  },
  {
    specialities_code: "11.13",
    specialities_name: "Anaplastology",
  },
  {
    specialities_code: "11.14",
    specialities_name: "Macular Dystrophy",
  },
  {
    specialities_code: "11.15",
    specialities_name: "Abyplopia",
  },
  {
    specialities_code: "11.16",
    specialities_name: "Ophthalmic Photography",
  },
  {
    specialities_code: "12.00",
    specialities_name: "Orthopedic Specialty",
  },
  {
    specialities_code: "12.01",
    specialities_name: "Oncology Orthopedic",
  },
  {
    specialities_code: "12.02",
    specialities_name: "Orthopedic Surgery",
  },
  {
    specialities_code: "12.03",
    specialities_name: "Pediatrics Orthopedic",
  },
  {
    specialities_code: "12.04",
    specialities_name: "Upper Limp Orthopedic",
  },
  {
    specialities_code: "13.00",
    specialities_name: "Pathology Specialty",
  },
  {
    specialities_code: "13.01",
    specialities_name: "Bone & Soft Tissue Pathology",
  },
  {
    specialities_code: "13.02",
    specialities_name: "Dermatopathology",
  },
  {
    specialities_code: "13.03",
    specialities_name: "Gast. & Hepat Pathology",
  },
  {
    specialities_code: "13.04",
    specialities_name: "Histopathology",
  },
  {
    specialities_code: "13.05",
    specialities_name: "Lymphoma Pathology",
  },
  {
    specialities_code: "13.06",
    specialities_name: "Pathology Dermatology",
  },
  {
    specialities_code: "13.07",
    specialities_name: "Renal Pathology",
  },
  {
    specialities_code: "14.00",
    specialities_name: "Pediatric Specialty",
  },
  {
    specialities_code: "14.01",
    specialities_name: "Fetal Medicine",
  },
  {
    specialities_code: "14.02",
    specialities_name: "Neonatal Intensive Care (NICU)",
  },
  {
    specialities_code: "14.03",
    specialities_name: "Pediatrics Imaging",
  },
  {
    specialities_code: "14.04",
    specialities_name: "Pediatrics Endocrinology",
  },
  {
    specialities_code: "14.05",
    specialities_name: "Pediatrics Gastroenterology",
  },
  {
    specialities_code: "14.06",
    specialities_name: "Pediatrics Genetics",
  },
  {
    specialities_code: "14.07",
    specialities_name: "Pediatrics Rheumatology",
  },
  {
    specialities_code: "14.08",
    specialities_name: "Pediatrics Sleep Medicine",
  },
  {
    specialities_code: "14.09",
    specialities_name: "Pediatrics Orthopedic",
  },
  {
    specialities_code: "14.10",
    specialities_name: "Pediatrics Hematology",
  },
  {
    specialities_code: "14.11",
    specialities_name: "Pediatrics Infectious Diseases",
  },
  {
    specialities_code: "14.12",
    specialities_name: "Pediatrics Intensive Care",
  },
  {
    specialities_code: "14.13",
    specialities_name: "Pediatrics Nephrology",
  },
  {
    specialities_code: "14.14",
    specialities_name: "Pediatrics Pulmonary Diseases",
  },
  {
    specialities_code: "14.15",
    specialities_name: "Primary Care Preventive Pediatrics",
  },
  {
    specialities_code: "14.16",
    specialities_name: "Pediatric Neurology",
  },
  {
    specialities_code: "14.17",
    specialities_name: "Fetal Cardiology",
  },
  {
    specialities_code: "14.18",
    specialities_name: "Neonatology",
  },
  {
    specialities_code: "14.19",
    specialities_name: "Pediatric Allergy",
  },
  {
    specialities_code: "14.20",
    specialities_name: "Pediatric Cardiology",
  },
  {
    specialities_code: "15.00",
    specialities_name: "Pediatrics Surgery Specialty",
  },
  {
    specialities_code: "15.01",
    specialities_name: "Pediatrics Cardiology",
  },
  {
    specialities_code: "15.02",
    specialities_name: "Pediatrics Neurosurgery",
  },
  {
    specialities_code: "15.03",
    specialities_name: "Pediatrics Oncology",
  },
  {
    specialities_code: "15.04",
    specialities_name: "Pediatrics Plastic Surgery",
  },
  {
    specialities_code: "15.05",
    specialities_name: "Pediatrics General Surgery",
  },
  {
    specialities_code: "15.06",
    specialities_name: "Pediatrics Hematology/Oncology",
  },
  {
    specialities_code: "16.00",
    specialities_name: "Physical Medicine & Rehabilitation Specialty",
  },
  {
    specialities_code: "16.01",
    specialities_name: "Physical Medicine & Rehabilitation",
  },
  {
    specialities_code: "16.02",
    specialities_name: "Occupational Medicine",
  },
  {
    specialities_code: "17.00",
    specialities_name: "Psychiatry Specialty",
  },
  {
    specialities_code: "17.01",
    specialities_name: "Addiction Medicine",
  },
  {
    specialities_code: "17.02",
    specialities_name: "Child / Adolescent Psychiatry",
  },
  {
    specialities_code: "17.03",
    specialities_name: "Consultation - Liaison Psychiatry",
  },
  {
    specialities_code: "17.04",
    specialities_name: "Forensic Psychiatry",
  },
  {
    specialities_code: "17.05",
    specialities_name: "Geriatric Psychiatry",
  },
  {
    specialities_code: "17.06",
    specialities_name: "Mental Health",
  },
  {
    specialities_code: "17.07",
    specialities_name: "Mood Disorders Psychiatry",
  },
  {
    specialities_code: "17.08",
    specialities_name: "Psychiatry",
  },
  {
    specialities_code: "17.09",
    specialities_name: "Rehabilitation Psychiatry",
  },
  {
    specialities_code: "17.10",
    specialities_name: "Schizophrenia",
  },
  {
    specialities_code: "17.11",
    specialities_name: "Pediatric Behavior",
  },
  {
    specialities_code: "17.12",
    specialities_name: "Youth Stress Reduction",
  },
  {
    specialities_code: "18.00",
    specialities_name: "Radiology Specialty",
  },
  {
    specialities_code: "18.01",
    specialities_name: "Body Imaging",
  },
  {
    specialities_code: "18.02",
    specialities_name: "Breast Imaging",
  },
  {
    specialities_code: "18.03",
    specialities_name: "Cardiac Imaging",
  },
  {
    specialities_code: "18.04",
    specialities_name: "Chest Imaging",
  },
  {
    specialities_code: "18.05",
    specialities_name: "Diagnostic Neuroradiology",
  },
  {
    specialities_code: "18.06",
    specialities_name: "Diagnostic Radiology",
  },
  {
    specialities_code: "18.07",
    specialities_name: "Emergency Radiology",
  },
  {
    specialities_code: "18.08",
    specialities_name: "Interventional Neuroradiology",
  },
  {
    specialities_code: "18.09",
    specialities_name: "Interventional Radiology",
  },
  {
    specialities_code: "18.10",
    specialities_name: "Musculoskeletal Imaging",
  },
  {
    specialities_code: "18.11",
    specialities_name: "Pediatrics Imaging",
  },
  {
    specialities_code: "18.12",
    specialities_name: "Womens Imaging",
  },
  {
    specialities_code: "19.00",
    specialities_name: "Surgery Specialty",
  },
  {
    specialities_code: "19.01",
    specialities_name: "Arthroplasty Surgery",
  },
  {
    specialities_code: "19.02",
    specialities_name: "Bariatric Surgery",
  },
  {
    specialities_code: "19.03",
    specialities_name: "Cosmetic Surgery",
  },
  {
    specialities_code: "19.04",
    specialities_name: "Craniofacial Surgery",
  },
  {
    specialities_code: "19.05",
    specialities_name: "Endocrinology Surgery",
  },
  {
    specialities_code: "19.06",
    specialities_name: "Facioplastic",
  },
  {
    specialities_code: "19.07",
    specialities_name: "Foot & Ankle Surgery",
  },
  {
    specialities_code: "19.08",
    specialities_name: "General Surgery",
  },
  {
    specialities_code: "19.09",
    specialities_name: "Hand Surgery",
  },
  {
    specialities_code: "19.10",
    specialities_name: "Hepatobiliary & Upper GI Surgery",
  },
  {
    specialities_code: "19.11",
    specialities_name: "Neurosurgery (Spinal Surgery)",
  },
  {
    specialities_code: "19.12",
    specialities_name: "Neurosurgery / Oncology",
  },
  {
    specialities_code: "19.13",
    specialities_name: "Neurosurgery Vascular",
  },
  {
    specialities_code: "19.14",
    specialities_name: "Plastic Surgery & Reconstruction",
  },
  {
    specialities_code: "19.15",
    specialities_name: "Skull Base Surgery",
  },
  {
    specialities_code: "19.16",
    specialities_name: "Spine Surgery",
  },
  {
    specialities_code: "19.17",
    specialities_name: "Thoracic Surgery/Chest Surgery",
  },
  {
    specialities_code: "19.18",
    specialities_name: "Trauma Surgery",
  },
  {
    specialities_code: "19.19",
    specialities_name: "Vascular Surgery",
  },
  {
    specialities_code: "19.20",
    specialities_name: "Colorectal Surgery",
  },
  {
    specialities_code: "19.21",
    specialities_name: "Transplant Surgery",
  },
  {
    specialities_code: "19.22",
    specialities_name: "Liver Transplant Surgery",
  },
  {
    specialities_code: "19.23",
    specialities_name: "Renal and Pancreas Transplant Surgery",
  },
  {
    specialities_code: "19.24",
    specialities_name: "Breast Surgery",
  },
  {
    specialities_code: "19.25",
    specialities_name: "Cardiothoracic Surgery",
  },
  {
    specialities_code: "19.26",
    specialities_name: "Burns",
  },
  {
    specialities_code: "20.00",
    specialities_name: "Urology Specialty",
  },
  {
    specialities_code: "20.01",
    specialities_name: "Gynecology Urology",
  },
  {
    specialities_code: "20.02",
    specialities_name: "Laparoscopic Urology",
  },
  {
    specialities_code: "20.03",
    specialities_name: "Neuro - Urology",
  },
  {
    specialities_code: "20.04",
    specialities_name: "Oncology Urology",
  },
  {
    specialities_code: "20.05",
    specialities_name: "Pediatrics Urology",
  },
  {
    specialities_code: "20.06",
    specialities_name: "Reconstruction Urology",
  },
  {
    specialities_code: "21.00",
    specialities_name: "Critical Care",
  },
  {
    specialities_code: "21.01",
    specialities_name: "Pediatric Critical Care (PICU)",
  },
  {
    specialities_code: "21.02",
    specialities_name: "Intensive Care (ICU)",
  },
  {
    specialities_code: "22.00",
    specialities_name: "Dental",
  },
  {
    specialities_code: "22.01",
    specialities_name: "Pediatric Dental",
  },
  {
    specialities_code: "22.02",
    specialities_name: "Prosthodontics",
  },
  {
    specialities_code: "22.03",
    specialities_name: "Endodontics",
  },
  {
    specialities_code: "22.04",
    specialities_name: "Periodontics",
  },
  {
    specialities_code: "22.05",
    specialities_name: "Orthodontics",
  },
  {
    specialities_code: "22.06",
    specialities_name: "Dental Implants",
  },
  {
    specialities_code: "22.07",
    specialities_name: "Dental Hygiene",
  },
  {
    specialities_code: "22.08",
    specialities_name: "Special Needs Dentistry",
  },
  {
    specialities_code: "23.00",
    specialities_name: "Neurophysiology",
  },
  {
    specialities_code: "24.00",
    specialities_name: "Speech/Speech Language Pathology",
  },
  {
    specialities_code: "25.00",
    specialities_name: "Infection Control",
  },
];
export const religionFullList = [
  {
    religion_code: "0",
    religion_name: "Other",
  },
  {
    religion_code: "1",
    religion_name: "Muslim",
  },
  {
    religion_code: "2",
    religion_name: "Christian",
  },
  {
    religion_code: "3",
    religion_name: "Judaism",
  },
  {
    religion_code: "4",
    religion_name: "Buddhism",
  },
  {
    religion_code: "5",
    religion_name: "Zoroastrian",
  },
  {
    religion_code: "7",
    religion_name: "Hinduism",
  },
  {
    religion_code: "8",
    religion_name: "Sikh",
  },
  {
    religion_code: "9",
    religion_name: "Without",
  },
  {
    religion_code: "98",
    religion_name: "Not available",
  },
  {
    religion_code: "99",
    religion_name: "Not Mentioned",
  },
];
export const maritalStatusFullList = [
  {
    maritalstatus_code: "L",
    maritalstatus_disply: "Legally Separated",
  },
  {
    maritalstatus_code: "D",
    maritalstatus_disply: "Divorced",
  },
  {
    maritalstatus_code: "M",
    maritalstatus_disply: "Married",
  },
  {
    maritalstatus_code: "U",
    maritalstatus_disply: "unmarried",
  },
  {
    maritalstatus_code: "W",
    maritalstatus_disply: "Widowed",
  },
];
export const serviceTypeFullList = [
  {
    servtype_code: "itm_prdt",
    servtype_name: "Product/Service",
  },
  {
    servtype_code: "itm_meddev",
    servtype_name: "Medical Devices",
  },
  {
    servtype_code: "itm_medcde",
    servtype_name: "Medical Code",
  },
  {
    servtype_code: "itm_hrblcde",
    servtype_name: "Herbal",
  },
];
export const MedicationServiceTypeFullList = [
  {
    servtype_code: "itm_meddev",
    servtype_name: "Medical Devices",
  },
  {
    servtype_code: "itm_medcde",
    servtype_name: "Medical Code",
  },
  {
    servtype_code: "itm_hrblcde",
    servtype_name: "Herbal",
  },
];
export const medicationAbsenceCodeFullList = [
  {
    absrsn_code: "Unresponsive",
    absrsn_name: "Unresponsive on certain trades",
  },
  {
    absrsn_code: "adverse-effect",
    absrsn_name: "Adverse effect",
  },
  {
    absrsn_code: "irreplaceable",
    absrsn_name: "SFDA Irreplaceable drugs",
  },
  {
    absrsn_code: "allergy",
    absrsn_name: "Allergy",
  },
  {
    absrsn_code: "herbal-vitamin",
    absrsn_name:
      "Item belonging to the Herbal, health drugs and vitamins list in SFDA\u00a0",
  },
  {
    absrsn_code: "others",
    absrsn_name: "Others\u00a0",
  },
];
export const selcectionAbsenceReasonFullList = [
  {
    pharmselrsn_code: "Generic",
    pharmselrsn_disply: "Generic",
  },
  {
    pharmselrsn_code: "patient-request",
    pharmselrsn_disply: "patient request",
  },
  {
    pharmselrsn_code: "innovative-noGeneric",
    pharmselrsn_disply: "innovative noGeneric",
  },
  {
    pharmselrsn_code: "physician-approval",
    pharmselrsn_disply: "physician-request with approval",
  },
  {
    pharmselrsn_code: "physician-no-approval",
    pharmselrsn_disply: "physician-request without approval",
  },
  {
    pharmselrsn_code: "drug-pharmacyUnavailable",
    pharmselrsn_disply: "drug-pharmacyUnavailable",
  },
  {
    pharmselrsn_code: "drug-nationallyUnavailable",
    pharmselrsn_disply: "drug-nationallyUnavailable",
  },
  {
    pharmselrsn_code: "Irreplaceable",
    pharmselrsn_disply: "SFDA Irreplaceable drugs",
  },
];
export const doseUnitFullList = [
  {
    ucumtype_code: "g",
    ucumtype_name: "Gram",
  },
  {
    ucumtype_code: "IU",
    ucumtype_name: "International Unit",
  },
  {
    ucumtype_code: "L",
    ucumtype_name: "Litre",
  },
  {
    ucumtype_code: "mg",
    ucumtype_name: "Milligram(s)",
  },
  {
    ucumtype_code: "mL",
    ucumtype_name: "Millilitre(s)",
  },
  {
    ucumtype_code: "ug",
    ucumtype_name: "Microgram(s)",
  },
  {
    ucumtype_code: "%",
    ucumtype_name: "Percentage",
  },
  {
    ucumtype_code: "mmol",
    ucumtype_name: "Millimole",
  },
  {
    ucumtype_code: "bar",
    ucumtype_name: "Bar",
  },
  {
    ucumtype_code: "ampule",
    ucumtype_name: "Ampule",
  },
  {
    ucumtype_code: "application",
    ucumtype_name: "Application",
  },
  {
    ucumtype_code: "bag",
    ucumtype_name: "Bag",
  },
  {
    ucumtype_code: "base",
    ucumtype_name: "Base",
  },
  {
    ucumtype_code: "blister",
    ucumtype_name: "Blister",
  },
  {
    ucumtype_code: "bottle",
    ucumtype_name: "Bottle",
  },
  {
    ucumtype_code: "box",
    ucumtype_name: "Box",
  },
  {
    ucumtype_code: "can",
    ucumtype_name: "Can",
  },
  {
    ucumtype_code: "capsule",
    ucumtype_name: "Capsule",
  },
  {
    ucumtype_code: "case",
    ucumtype_name: "Case",
  },
  {
    ucumtype_code: "cup",
    ucumtype_name: "Cup",
  },
  {
    ucumtype_code: "disc",
    ucumtype_name: "Disc",
  },
  {
    ucumtype_code: "drop",
    ucumtype_name: "Drop",
  },
  {
    ucumtype_code: "dropperful",
    ucumtype_name: "Dropperful",
  },
  {
    ucumtype_code: "dual dose sachet",
    ucumtype_name: "Dual Dose Sachet",
  },
  {
    ucumtype_code: "glassful",
    ucumtype_name: "Glassful",
  },
  {
    ucumtype_code: "gum",
    ucumtype_name: "Gum",
  },
  {
    ucumtype_code: "implant",
    ucumtype_name: "Implant",
  },
  {
    ucumtype_code: "inhalation",
    ucumtype_name: "Inhalation",
  },
  {
    ucumtype_code: "insert",
    ucumtype_name: "Insert",
  },
  {
    ucumtype_code: "kit",
    ucumtype_name: "Kit",
  },
  {
    ucumtype_code: "lozenge",
    ucumtype_name: "Lozenge",
  },
  {
    ucumtype_code: "packet",
    ucumtype_name: "Packet",
  },
  {
    ucumtype_code: "pad",
    ucumtype_name: "Pad",
  },
  {
    ucumtype_code: "patch",
    ucumtype_name: "Patch",
  },
  {
    ucumtype_code: "pellet",
    ucumtype_name: "Pellet",
  },
  {
    ucumtype_code: "puff",
    ucumtype_name: "Puff",
  },
  {
    ucumtype_code: "sachet",
    ucumtype_name: "Sachet",
  },
  {
    ucumtype_code: "scoop",
    ucumtype_name: "Scoop",
  },
  {
    ucumtype_code: "sponge",
    ucumtype_name: "Sponge",
  },
  {
    ucumtype_code: "spray",
    ucumtype_name: "Spray",
  },
  {
    ucumtype_code: "suppository",
    ucumtype_name: "Suppository",
  },
  {
    ucumtype_code: "swab",
    ucumtype_name: "Swab",
  },
  {
    ucumtype_code: "tablespoonful",
    ucumtype_name: "Tablespoonful",
  },
  {
    ucumtype_code: "tablet",
    ucumtype_name: "Tablet",
  },
  {
    ucumtype_code: "teaspoon",
    ucumtype_name: "Teaspoon",
  },
  {
    ucumtype_code: "tube",
    ucumtype_name: "Tube",
  },
  {
    ucumtype_code: "vial",
    ucumtype_name: "Vial",
  },
  {
    ucumtype_code: "penfill syringe",
    ucumtype_name: "Penfill Syringe",
  },
];
export const routeFullList = [
  {
    ruteadmn_code: "EBPROA0001",
    ruteadmn_name: "BUCCAL",
  },
  {
    ruteadmn_code: "EBPROA0002",
    ruteadmn_name: "CONJUNCTIVAL",
  },
  {
    ruteadmn_code: "EBPROA0003",
    ruteadmn_name: "CUTANEOUS",
  },
  {
    ruteadmn_code: "EBPROA0004",
    ruteadmn_name: "DENTAL",
  },
  {
    ruteadmn_code: "EBPROA0005",
    ruteadmn_name: "ENDOCERVICAL",
  },
  {
    ruteadmn_code: "EBPROA0006",
    ruteadmn_name: "ENDOSINUSIAL",
  },
  {
    ruteadmn_code: "EBPROA0007",
    ruteadmn_name: "ENDOTRACHEAL",
  },
  {
    ruteadmn_code: "EBPROA0008",
    ruteadmn_name: "ENTERAL",
  },
  {
    ruteadmn_code: "EBPROA0009",
    ruteadmn_name: "EPIDURAL",
  },
  {
    ruteadmn_code: "EBPROA0010",
    ruteadmn_name: "EXTRA‑AMNIOTIC",
  },
  {
    ruteadmn_code: "EBPROA0011",
    ruteadmn_name: "HEMODIALYSIS",
  },
  {
    ruteadmn_code: "EBPROA0012",
    ruteadmn_name: "INFILTRATION",
  },
  {
    ruteadmn_code: "EBPROA0013",
    ruteadmn_name: "INTERSTITIAL ",
  },
  {
    ruteadmn_code: "EBPROA0014",
    ruteadmn_name: "INTRA-ABDOMINAL",
  },
  {
    ruteadmn_code: "EBPROA0015",
    ruteadmn_name: "INTRA-AMNIOTIC",
  },
  {
    ruteadmn_code: "EBPROA0016",
    ruteadmn_name: "INTRA-ARTERIAL",
  },
  {
    ruteadmn_code: "EBPROA0017",
    ruteadmn_name: "INTRA-ARTICULAR",
  },
  {
    ruteadmn_code: "EBPROA0018",
    ruteadmn_name: "INTRABILIARY",
  },
  {
    ruteadmn_code: "EBPROA0019",
    ruteadmn_name: "INTRABRONCHIAL",
  },
  {
    ruteadmn_code: "EBPROA0020",
    ruteadmn_name: "INTRABURSAL",
  },
  {
    ruteadmn_code: "EBPROA0021",
    ruteadmn_name: "INTRACARDIAC",
  },
  {
    ruteadmn_code: "EBPROA0022",
    ruteadmn_name: "INTRACARTILAGINOUS",
  },
  {
    ruteadmn_code: "EBPROA0023",
    ruteadmn_name: "INTRACAUDAL",
  },
  {
    ruteadmn_code: "EBPROA0024",
    ruteadmn_name: "INTRACAVERNOUS",
  },
  {
    ruteadmn_code: "EBPROA0025",
    ruteadmn_name: "INTRACEREBRAL",
  },
  {
    ruteadmn_code: "EBPROA0026",
    ruteadmn_name: "INTRACISTERNAL",
  },
  {
    ruteadmn_code: "EBPROA0027",
    ruteadmn_name: "INTRACORNEAL",
  },
  {
    ruteadmn_code: "EBPROA0028",
    ruteadmn_name: "INTRACORONAL, DENTAL",
  },
  {
    ruteadmn_code: "EBPROA0029",
    ruteadmn_name: "INTRACORONARY",
  },
  {
    ruteadmn_code: "EBPROA0030",
    ruteadmn_name: "INTRACORPORUS CAVERNOSUM",
  },
  {
    ruteadmn_code: "EBPROA0031",
    ruteadmn_name: "INTRADERMAL",
  },
  {
    ruteadmn_code: "EBPROA0032",
    ruteadmn_name: "INTRADISCAL",
  },
  {
    ruteadmn_code: "EBPROA0033",
    ruteadmn_name: "INTRADUCTAL",
  },
  {
    ruteadmn_code: "EBPROA0034",
    ruteadmn_name: "INTRADUODENAL",
  },
  {
    ruteadmn_code: "EBPROA0035",
    ruteadmn_name: "INTRADURAL",
  },
  {
    ruteadmn_code: "EBPROA0036",
    ruteadmn_name: "INTRAEPIDERMAL",
  },
  {
    ruteadmn_code: "EBPROA0037",
    ruteadmn_name: "INTRAESOPHAGEAL",
  },
  {
    ruteadmn_code: "EBPROA0038",
    ruteadmn_name: "INTRAGASTRIC",
  },
  {
    ruteadmn_code: "EBPROA0039",
    ruteadmn_name: "INTRAGINGIVAL",
  },
  {
    ruteadmn_code: "EBPROA0040",
    ruteadmn_name: "INTRAILEAL",
  },
  {
    ruteadmn_code: "EBPROA0041",
    ruteadmn_name: "INTRALESIONAL",
  },
  {
    ruteadmn_code: "EBPROA0042",
    ruteadmn_name: "INTRALUMINAL",
  },
  {
    ruteadmn_code: "EBPROA0043",
    ruteadmn_name: "INTRALYMPHATIC",
  },
  {
    ruteadmn_code: "EBPROA0044",
    ruteadmn_name: "INTRAMEDULLARY",
  },
  {
    ruteadmn_code: "EBPROA0045",
    ruteadmn_name: "INTRAMENINGEAL",
  },
  {
    ruteadmn_code: "EBPROA0046",
    ruteadmn_name: "INTRAMUSCULAR",
  },
  {
    ruteadmn_code: "EBPROA0047",
    ruteadmn_name: "INTRAOCULAR",
  },
  {
    ruteadmn_code: "EBPROA0048",
    ruteadmn_name: "INTRAOVARIAN",
  },
  {
    ruteadmn_code: "EBPROA0049",
    ruteadmn_name: "INTRAPERICARDIAL",
  },
  {
    ruteadmn_code: "EBPROA0050",
    ruteadmn_name: "INTRAPERITONEAL",
  },
  {
    ruteadmn_code: "EBPROA0051",
    ruteadmn_name: "INTRAPLEURAL",
  },
  {
    ruteadmn_code: "EBPROA0052",
    ruteadmn_name: "INTRAPROSTATIC",
  },
  {
    ruteadmn_code: "EBPROA0053",
    ruteadmn_name: "INTRAPULMONARY",
  },
  {
    ruteadmn_code: "EBPROA0054",
    ruteadmn_name: "INTRASINAL",
  },
  {
    ruteadmn_code: "EBPROA0055",
    ruteadmn_name: "INTRASPINAL",
  },
  {
    ruteadmn_code: "EBPROA0056",
    ruteadmn_name: "INTRASYNOVIAL",
  },
  {
    ruteadmn_code: "EBPROA0057",
    ruteadmn_name: "INTRATENDINOUS",
  },
  {
    ruteadmn_code: "EBPROA0058",
    ruteadmn_name: "INTRATESTICULAR",
  },
  {
    ruteadmn_code: "EBPROA0059",
    ruteadmn_name: "INTRATHECAL",
  },
  {
    ruteadmn_code: "EBPROA0060",
    ruteadmn_name: "INTRATHORACIC",
  },
  {
    ruteadmn_code: "EBPROA0061",
    ruteadmn_name: "INTRATUBULAR",
  },
  {
    ruteadmn_code: "EBPROA0062",
    ruteadmn_name: "INTRATUMOR",
  },
  {
    ruteadmn_code: "EBPROA0063",
    ruteadmn_name: "INTRATYMPANIC",
  },
  {
    ruteadmn_code: "EBPROA0064",
    ruteadmn_name: "INTRAUTERINE",
  },
  {
    ruteadmn_code: "EBPROA0065",
    ruteadmn_name: "INTRAVASCULAR",
  },
  {
    ruteadmn_code: "EBPROA0066",
    ruteadmn_name: "INTRAVENOUS",
  },
  {
    ruteadmn_code: "EBPROA0067",
    ruteadmn_name: "INTRAVENOUS BOLUS",
  },
  {
    ruteadmn_code: "EBPROA0068",
    ruteadmn_name: "INTRAVENOUS DRIP",
  },
  {
    ruteadmn_code: "EBPROA0069",
    ruteadmn_name: "INTRAVENTRICULAR",
  },
  {
    ruteadmn_code: "EBPROA0070",
    ruteadmn_name: "INTRAVESICAL",
  },
  {
    ruteadmn_code: "EBPROA0071",
    ruteadmn_name: "INTRAVITREAL",
  },
  {
    ruteadmn_code: "EBPROA0072",
    ruteadmn_name: "IONTOPHORESIS",
  },
  {
    ruteadmn_code: "EBPROA0073",
    ruteadmn_name: "IRRIGATION",
  },
  {
    ruteadmn_code: "EBPROA0074",
    ruteadmn_name: "LARYNGEAL",
  },
  {
    ruteadmn_code: "EBPROA0075",
    ruteadmn_name: "NASAL",
  },
  {
    ruteadmn_code: "EBPROA0076",
    ruteadmn_name: "NASOGASTRIC",
  },
  {
    ruteadmn_code: "EBPROA0077",
    ruteadmn_name: "OCCLUSIVE DRESSING TECHNIQUE",
  },
  {
    ruteadmn_code: "EBPROA0078",
    ruteadmn_name: "OPHTHALMIC",
  },
  {
    ruteadmn_code: "EBPROA0079",
    ruteadmn_name: "ORAL",
  },
  {
    ruteadmn_code: "EBPROA0080",
    ruteadmn_name: "OROPHARYNGEAL",
  },
  {
    ruteadmn_code: "EBPROA0081",
    ruteadmn_name: "OTIC (AURICULAR) ",
  },
  {
    ruteadmn_code: "EBPROA0082",
    ruteadmn_name: "PERCUTANEOUS",
  },
  {
    ruteadmn_code: "EBPROA0083",
    ruteadmn_name: "PERIARTICULAR",
  },
  {
    ruteadmn_code: "EBPROA0084",
    ruteadmn_name: "PERIDURAL",
  },
  {
    ruteadmn_code: "EBPROA0085",
    ruteadmn_name: "PERINEURAL",
  },
  {
    ruteadmn_code: "EBPROA0086",
    ruteadmn_name: "PERIODONTAL",
  },
  {
    ruteadmn_code: "EBPROA0087",
    ruteadmn_name: "RECTAL",
  },
  {
    ruteadmn_code: "EBPROA0088",
    ruteadmn_name: "RESPIRATORY (INHALATION)",
  },
  {
    ruteadmn_code: "EBPROA0089",
    ruteadmn_name: "RETROBULBAR",
  },
  {
    ruteadmn_code: "EBPROA0090",
    ruteadmn_name: "SOFT TISSUE",
  },
  {
    ruteadmn_code: "EBPROA0091",
    ruteadmn_name: "SUBARACHNOID",
  },
  {
    ruteadmn_code: "EBPROA0092",
    ruteadmn_name: "SUBCONJUNCTIVAL",
  },
  {
    ruteadmn_code: "EBPROA0093",
    ruteadmn_name: "SUBCUTANEOUS",
  },
  {
    ruteadmn_code: "EBPROA0094",
    ruteadmn_name: "SUBLINGUAL",
  },
  {
    ruteadmn_code: "EBPROA0095",
    ruteadmn_name: "TOPICAL",
  },
  {
    ruteadmn_code: "EBPROA0096",
    ruteadmn_name: "TRANSDERMAL",
  },
  {
    ruteadmn_code: "EBPROA0097",
    ruteadmn_name: "TRANSMUCOSAL",
  },
  {
    ruteadmn_code: "EBPROA0098",
    ruteadmn_name: "TRANSPLACENTAL",
  },
  {
    ruteadmn_code: "EBPROA0099",
    ruteadmn_name: "TRANSTRACHEAL",
  },
  {
    ruteadmn_code: "EBPROA0100",
    ruteadmn_name: "URETERAL",
  },
  {
    ruteadmn_code: "EBPROA0101",
    ruteadmn_name: "URETHRAL",
  },
  {
    ruteadmn_code: "EBPROA0102",
    ruteadmn_name: "VAGINAL",
  },
  {
    ruteadmn_code: "EBPROA0103",
    ruteadmn_name: "NOT APPLICABLE",
  },
  {
    ruteadmn_code: "EBPROA0104",
    ruteadmn_name: "UNASSIGNED",
  },
  {
    ruteadmn_code: "EBPROA0105",
    ruteadmn_name: "UNKNOWN",
  },
];
export const timeInstructionFullList = [
  { time_instCode: "BID", time_instDisplay: "Two time a day" },
  { time_instCode: "TID", time_instDisplay: "Three time a day" },
  { time_instCode: "QID", time_instDisplay: "Four time a day" },
  { time_instCode: "AM", time_instDisplay: "Every Morning" },
  { time_instCode: "PM", time_instDisplay: "Every Afternoon" },
  { time_instCode: "QD", time_instDisplay: "Every day" },
  { time_instCode: "QOD", time_instDisplay: "Every Other day" },
];

export const nationalityList = [
  "ABW",
  "AFG",
  "AGO",
  "AIA",
  "ALA",
  "ALB",
  "AND",
  "ARE",
  "ARG",
  "ARM",
  "ASM",
  "ATA",
  "ATF",
  "ATG",
  "AUS",
  "AUT",
  "AZE",
  "BDI",
  "BEL",
  "BEN",
  "BES",
  "BFA",
  "BGD",
  "BGR",
  "BHR",
  "BHS",
  "BIH",
  "BLM",
  "BLR",
  "BLZ",
  "BMU",
  "BOL",
  "BRA",
  "BRB",
  "BRN",
  "BTN",
  "BVT",
  "BWA",
  "CAF",
  "CAN",
  "CCK",
  "CHE",
  "CHL",
  "CHN",
  "CIV",
  "CMR",
  "COD",
  "COG",
  "COK",
  "COL",
  "COM",
  "CPV",
  "CRI",
  "CUB",
  "CUW",
  "CXR",
  "CYM",
  "CYP",
  "CZE",
  "DEU",
  "DJI",
  "DMA",
  "DNK",
  "DOM",
  "DZA",
  "ECU",
  "EGY",
  "ERI",
  "ESH",
  "ESP",
  "EST",
  "ETH",
  "FIN",
  "FJI",
  "FLK",
  "FRA",
  "FRO",
  "FSM",
  "GAB",
  "GBR",
  "GEO",
  "GGY",
  "GHA",
  "GIB",
  "GIN",
  "GLP",
  "GMB",
  "GNB",
  "GNQ",
  "GRC",
  "GRD",
  "GRL",
  "GTM",
  "GUF",
  "GUM",
  "GUY",
  "HKG",
  "HMD",
];
export const genderList = [
  "male",
  "female",
  "unknown",
  "undetermined",
  "undiffrentiated",
  "sex changed to male",
  "sex changed to female",
];
export const isNewBornList = ["Y", "N"];
export const visitTypeList = [
  "new-visit",
  "follow-up",
  "refill",
  "walk-in",
  "referral",
];
export const careTypeList = [
  "sub-acute-care",
  "acute-care",
  "rehabilitation",
  "mental-behavioral",
  "geriatric-care",
  "newborn",
  "family-planning",
  "dental-care",
  "palliative-care",
  "others",
  "unknown",
];
export const triageCategoryList = ["IR", "VU", "U", "SER", "NU"];
export const departmentDispositionList = [
  "AH",
  "NAD",
  "NAR",
  "DNW",
  "LAOR",
  "DED",
  "DOA",
  "R",
];
export const occupationList = [
  "administration",
  "agriculture",
  "business",
  "education",
  "housewife",
  "marine",
  "medical field",
  "military",
  "skilled worker",
  "student",
  "oil industries",
  "unemployed",
  "others",
  "unknown",
];
export const serviceEventTypeList = ["ICSE", "SCSE"];
export const emergencyArrivalCodeList = [
  "GEMSA",
  "MOHA",
  "GCDA",
  "GMA",
  "GPA",
  "EMSAA",
  "ACDA",
  "AMA",
  "PV",
  "OGV",
  "PV",
  "other",
  "unknown",
];
export const emergencyDepartmentDispositionList = [
  "AH",
  "NAD",
  "NAR",
  "DNW",
  "LAOR",
  "DED",
  "DOA",
  "R",
];
export const intendLengthStayList = ["ISD", "IO"];
export const encounterClassList = ["AMB", "VR", "HH", "IMP", "SS", "ACU"];
export const admitSourceList = [
  "IA",
  "EER",
  "EOP",
  "EGPHC",
  "EGGH",
  "EPPHC",
  "EPH",
  "EIC",
  "EWGS",
  "EWSS",
  "EWIS",
  "EMBA",
  "PMBA",
  "RECR",
  "WKIN",
  "FMLYM",
  "AA",
  "PVAMB",
  "AAIC",
  "Others",
];
export const dischargeDispositionList = [
  "acute-hospital",
  "SDTC",
  "SDFL",
  "home",
  "DTRAS",
  "DTPH",
  "DTOHA",
  "LAMA",
  "died",
  "in-hospital",
];
export const encounterStatusList = [
  "planned",
  "arrived",
  "triaged",
  "in-progress",
  "onleave",
  "finished",
  "cancelled",
  "entered-in-error",
  "unknown",
];
export const accidentTypeList = ["MVA", "SCHOOL", "SPT", "WPA"];
export const missingToothNumberList = [
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "51",
  "52",
  "53",
  "54",
  "55",
  "61",
  "62",
  "63",
  "64",
  "65",
  "71",
  "72",
  "73",
  "74",
  "75",
  "81",
  "82",
  "83",
  "84",
  "85",
];
export const missingToothReason = ["e", "c", "u", "o"];
export const relationshipList = [
  "child",
  "parent",
  "spouse",
  "common",
  "other",
  "self",
  "injured",
];
export const roleList = ["primary", "assist", "supervisor", "other"];
export const toothSurfaceList = [
  "R",
  "L",
  "U",
  "D",
  "A",
  "P",
  "I",
  "E",
  "M",
  "O",
  "I",
  "D",
  "B",
  "V",
  "L",
  "MO",
  "DO",
  "DI",
  "MOD",
];
export const bodySiteList = [
  "E1",
  "E2",
  "E3",
  "E4",
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "FA",
  "LC",
  "LD",
  "LM",
  "LT",
  "RC",
  "RI",
  "RT",
  "T1",
  "T2",
  "T3",
  "T4",
  "T5",
  "T6",
  "T7",
  "T8",
  "T9",
  "TA",
  "RIV",
  "LIV",
];
export const bodySubSiteList = [
  "R",
  "L",
  "U",
  "D",
  "A",
  "P",
  "I",
  "E",
  "M",
  "O",
  "I",
  "D",
  "B",
  "V",
  "L",
  "MO",
  "DO",
  "DI",
  "MOD",
];
export const pharmacySubstitueList = [
  "strength-not-available",
  "form-not-available",
  "Irreplaceable",
  "Others",
];
export const durationUnitList = [
  "second",
  "minute",
  "hour",
  "day",
  "week",
  "month",
  "year",
];
export const diagtypeCodesList = [
  "principal",
  "admitting",
  "differential",
  "secondary",
  "discharge",
];
export const conditionOnsetList = ["NR", "CNNA", "COEA"];
export const onAdmissionList = ["U", "Y", "N"];
export const productTypeList = ["lens", "contact"];
export const regularLenseTypeList = ["glass", "plastic", "other"];
export const lensSpecificationList = [
  "multicoated",
  "multifocal",
  "light",
  "aspheric",
  "bifocal",
  "medium",
  "lenticular",
  "antiscratch",
  "dark",
  "safetythikness",
  "antireflectingcoating",
  "photosensitive",
  "highindex",
  "colored",
  "singlevision",
  "varilux",
];
export const contactLenseTypeList = ["disposable", "permanent"];
export const addList = [
  "-12.00",
  "-11.75",
  "-11.50",
  "-11.25",
  "-11.00",
  "-10.75",
  "-10.50",
  "-10.25",
  "-10.00",
  "-9.75",
  "-9.50",
  "-9.25",
  "-9.00",
  "-8.75",
  "-8.50",
  "-8.25",
  "-8.00",
  "-7.75",
  "-7.50",
  "-7.25",
  "-7.00",
  "-6.75",
  "-6.50",
  "-6.25",
  "-6.00",
  "-5.75",
  "-5.50",
  "-5.25",
  "-5.00",
  "-4.75",
  "-4.50",
  "-4.25",
  "-4.00",
  "-3.75",
  "-3.50",
  "-3.25",
  "-3.00",
  "-2.75",
  "-2.50",
  "-2.25",
  "-2.00",
  "-1.75",
  "-1.50",
  "-1.25",
  "-1.00",
  "-0.75",
  "-0.50",
  "-0.25",
  "0.00",
  "0.25",
  "0.50",
  "0.75",
  "1.00",
  "1.25",
  "1.50",
  "1.75",
  "2.00",
  "2.25",
  "2.50",
  "2.75",
  "3.00",
  "3.25",
  "3.50",
  "3.75",
  "4.00",
  "4.25",
  "4.50",
  "4.75",
  "5.00",
  "5.25",
  "5.50",
  "5.75",
  "6.00",
  "6.25",
  "6.50",
  "6.75",
  "7.00",
  "7.25",
  "7.50",
  "7.75",
  "8.00",
  "8.25",
  "8.50",
  "8.75",
  "9.00",
  "9.25",
  "9.50",
  "9.75",
  "10.00",
  "10.25",
  "10.50",
  "10.75",
  "11.00",
  "11.25",
  "11.50",
  "11.75",
  "12.00",
];
export const axisList = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "98",
  "99",
  "100",
  "101",
  "102",
  "103",
  "104",
  "105",
  "106",
  "107",
  "108",
  "109",
  "110",
  "111",
  "112",
  "113",
  "114",
  "115",
  "116",
  "117",
  "118",
  "119",
  "120",
  "121",
  "122",
  "123",
  "124",
  "125",
  "126",
  "127",
  "128",
  "129",
  "130",
  "131",
  "132",
  "133",
  "134",
  "135",
  "136",
  "137",
  "138",
  "139",
  "140",
  "141",
  "142",
  "143",
  "144",
  "145",
  "146",
  "147",
  "148",
  "149",
  "150",
  "151",
  "152",
  "153",
  "154",
  "155",
  "156",
  "157",
  "158",
  "159",
  "160",
  "161",
  "162",
  "163",
  "164",
  "165",
  "166",
  "167",
  "168",
  "169",
  "170",
  "171",
  "172",
  "173",
  "174",
  "175",
  "176",
  "177",
  "178",
  "179",
  "180",
];
export const powerList = [
  "-12",
  "-11.75",
  "-11.5",
  "-11.25",
  "-11",
  "-10.75",
  "-10.5",
  "-10.25",
  "-10",
  "-9.75",
  "-9.5",
  "-9.25",
  "-9",
  "-8.75",
  "-8.5",
  "-8.25",
  "-8",
  "-7.75",
  "-7.5",
  "-7.25",
  "-7",
  "-6.75",
  "-6.5",
  "-6.25",
  "-6",
  "-5.75",
  "-5.5",
  "-5.25",
  "-5",
  "-4.75",
  "-4.5",
  "-4.25",
  "-4",
  "-3.75",
  "-3.5",
  "-3.25",
  "-3",
  "-2.75",
  "-2.5",
  "-2.25",
  "-2",
  "-1.75",
  "-1.5",
  "-1.25",
  "-1",
  "-0.75",
  "-0.5",
  "-0.25",
  "0",
  "0.25",
  "0.5",
  "0.75",
  "1",
  "1.25",
  "1.5",
  "1.75",
  "2",
  "2.25",
  "2.5",
  "2.75",
  "3",
  "3.25",
  "3.5",
  "3.75",
  "4",
  "4.25",
  "4.5",
  "4.75",
  "5",
  "5.25",
  "5.5",
  "5.75",
  "6",
  "6.25",
  "6.5",
  "6.75",
  "7",
  "7.25",
  "7.5",
  "7.75",
  "8",
  "8.25",
  "8.5",
  "8.75",
  "9",
  "9.25",
  "9.5",
  "9.75",
  "10",
  "10.25",
  "10.5",
  "10.75",
  "11",
  "11.25",
  "11.5",
  "11.75",
  "12",
];
export const diameterList = [
  "5.0",
  "5.1",
  "5.2",
  "5.3",
  "5.4",
  "5.5",
  "5.6",
  "5.7",
  "5.8",
  "5.9",
  "6.0",
  "6.1",
  "6.2",
  "6.3",
  "6.4",
  "6.5",
  "6.6",
  "6.7",
  "6.8",
  "6.9",
  "7.0",
  "7.1",
  "7.2",
  "7.3",
  "7.4",
  "7.5",
  "7.6",
  "7.7",
  "7.8",
  "7.9",
  "8.0",
  "8.1",
  "8.2",
  "8.3",
  "8.4",
  "8.5",
  "8.6",
  "8.7",
  "8.8",
  "8.9",
  "9.0",
  "9.1",
  "9.2",
  "9.3",
  "9.4",
  "9.5",
  "9.6",
  "9.7",
  "9.8",
  "9.9",
  "10.0",
  "10.1",
  "10.2",
  "10.3",
  "10.4",
  "10.5",
  "10.6",
  "10.7",
  "10.8",
  "10.9",
  "11.0",
  "11.1",
  "11.2",
  "11.3",
  "11.4",
  "11.5",
  "11.6",
  "11.7",
  "11.8",
  "11.9",
  "12.0",
  "12.1",
  "12.2",
  "12.3",
  "12.4",
  "12.5",
  "12.6",
  "12.7",
  "12.8",
  "12.9",
  "13.0",
  "13.1",
  "13.2",
  "13.3",
  "13.4",
  "13.5",
  "13.6",
  "13.7",
  "13.8",
  "13.9",
  "14.0",
  "14.1",
  "14.2",
  "14.3",
  "14.4",
  "14.5",
  "14.6",
  "14.7",
  "14.8",
  "14.9",
  "15.0",
  "15.1",
  "15.2",
  "15.3",
  "15.4",
  "15.5",
  "15.6",
  "15.7",
  "15.8",
  "15.9",
  "16.0",
  "16.1",
  "16.2",
  "16.3",
  "16.4",
  "16.5",
  "16.6",
  "16.7",
  "16.8",
  "16.9",
  "17.0",
  "17.1",
  "17.2",
  "17.3",
  "17.4",
  "17.5",
  "17.6",
  "17.7",
  "17.8",
  "17.9",
  "18.0",
  "18.1",
  "18.2",
  "18.3",
  "18.4",
  "18.5",
  "18.6",
  "18.7",
  "18.8",
  "18.9",
  "19.0",
  "19.1",
  "19.2",
  "19.3",
  "19.4",
  "19.5",
  "19.6",
  "19.7",
  "19.8",
  "19.9",
  "20.0",
  "20.1",
  "20.2",
  "20.3",
  "20.4",
  "20.5",
  "20.6",
  "20.7",
  "20.8",
  "20.9",
  "21.0",
  "21.1",
  "21.2",
  "21.3",
  "21.4",
  "21.5",
  "21.6",
  "21.7",
  "21.8",
  "21.9",
  "22.0",
  "22.1",
  "22.2",
  "22.3",
  "22.4",
  "22.5",
  "22.6",
  "22.7",
  "22.8",
  "22.9",
  "23.0",
  "23.1",
  "23.2",
  "23.3",
  "23.4",
  "23.5",
  "23.6",
  "23.7",
  "23.8",
  "23.9",
  "24.0",
  "24.1",
  "24.2",
  "24.3",
  "24.4",
  "24.5",
  "24.6",
  "24.7",
  "24.8",
  "24.9",
  "25.0",
  "25.1",
  "25.2",
  "25.3",
  "25.4",
  "25.5",
  "25.6",
  "25.7",
  "25.8",
  "25.9",
  "26.0",
  "26.1",
  "26.2",
  "26.3",
  "26.4",
  "26.5",
  "26.6",
  "26.7",
  "26.8",
  "26.9",
  "27.0",
  "27.1",
  "27.2",
  "27.3",
  "27.4",
  "27.5",
  "27.6",
  "27.7",
  "27.8",
  "27.9",
  "28.0",
  "28.1",
  "28.2",
  "28.3",
  "28.4",
  "28.5",
  "28.6",
  "28.7",
  "28.8",
  "28.9",
  "29.0",
  "29.1",
  "29.2",
  "29.3",
  "29.4",
  "29.5",
  "29.6",
  "29.7",
  "29.8",
  "29.9",
  "30.0",
];
export const backcurveList = [
  "4.0",
  "4.1",
  "4.2",
  "4.3",
  "4.4",
  "4.5",
  "4.6",
  "4.7",
  "4.8",
  "4.9",
  "5.0",
  "5.1",
  "5.2",
  "5.3",
  "5.4",
  "5.5",
  "5.6",
  "5.7",
  "5.8",
  "5.9",
  "6.0",
  "6.1",
  "6.2",
  "6.3",
  "6.4",
  "6.5",
  "6.6",
  "6.7",
  "6.8",
  "6.9",
  "7.0",
  "7.1",
  "7.2",
  "7.3",
  "7.4",
  "7.5",
  "7.6",
  "7.7",
  "7.8",
  "7.9",
  "8.0",
];
export const prismList = [
  "0.00",
  "0.50",
  "1.00",
  "1.50",
  "2.00",
  "2.50",
  "3.00",
  "3.50",
  "4.00",
  "4.50",
  "5.00",
  "5.50",
  "6.00",
  "6.50",
  "7.00",
  "7.50",
  "8.00",
  "8.50",
  "9.00",
  "9.50",
  "10.00",
];

export const shereList = [
  "-20.00",
  "-19.75",
  "-19.50",
  "-19.25",
  "-19.00",
  "-18.75",
  "-18.50",
  "-18.25",
  "-18.00",
  "-17.75",
  "-17.50",
  "-17.25",
  "-17.00",
  "-16.75",
  "-16.50",
  "-16.25",
  "-16.00",
  "-15.75",
  "-15.50",
  "-15.25",
  "-15.00",
  "-14.75",
  "-14.50",
  "-14.25",
  "-14.00",
  "-13.75",
  "-13.50",
  "-13.25",
  "-13.00",
  "-12.75",
  "-12.50",
  "-12.25",
  "-12.00",
  "-11.75",
  "-11.50",
  "-11.25",
  "-11.00",
  "-10.75",
  "-10.50",
  "-10.25",
  "-10.00",
  "-9.75",
  "-9.50",
  "-9.25",
  "-9.00",
  "-8.75",
  "-8.50",
  "-8.25",
  "-8.00",
  "-7.75",
  "-7.50",
  "-7.25",
  "-7.00",
  "-6.75",
  "-6.50",
  "-6.25",
  "-6.00",
  "-5.75",
  "-5.50",
  "-5.25",
  "-5.00",
  "-4.75",
  "-4.50",
  "-4.25",
  "-4.00",
  "-3.75",
  "-3.50",
  "-3.25",
  "-3.00",
  "-2.75",
  "-2.50",
  "-2.25",
  "-2.00",
  "-1.75",
  "-1.50",
  "-1.25",
  "-1.00",
  "-0.75",
  "-0.50",
  "-0.25",
  "0.00",
  "0.25",
  "0.50",
  "0.75",
  "1.00",
  "1.25",
  "1.50",
  "1.75",
  "2.00",
  "2.25",
  "2.50",
  "2.75",
  "3.00",
  "3.25",
  "3.50",
  "3.75",
  "4.00",
  "4.25",
  "4.50",
  "4.75",
  "5.00",
  "5.25",
  "5.50",
  "5.75",
  "6.00",
  "6.25",
  "6.50",
  "6.75",
  "7.00",
  "7.25",
  "7.50",
  "7.75",
  "8.00",
  "8.25",
  "8.50",
  "8.75",
  "9.00",
  "9.25",
  "9.50",
  "9.75",
  "10.00",
  "10.25",
  "10.50",
  "10.75",
  "11.00",
  "11.25",
  "11.50",
  "11.75",
  "12.00",
  "12.25",
  "12.50",
  "12.75",
  "13.00",
  "13.25",
  "13.50",
  "13.75",
  "14.00",
  "14.25",
  "14.50",
  "14.75",
  "15.00",
  "15.25",
  "15.50",
  "15.75",
  "16.00",
  "16.25",
  "16.50",
  "16.75",
  "17.00",
  "17.25",
  "17.50",
  "17.75",
  "18.00",
  "18.25",
  "18.50",
  "18.75",
  "19.00",
  "19.25",
  "19.50",
  "19.75",
  "20.00",
];

export const opticalDurationList = ["D", "WK", "MO"];
